import React from 'react';

import { useLanguage } from 'Context/LanguageContext';
import { Col } from 'react-bootstrap';
import AsyncSearch from 'OldComponents/AsyncSearch/AsyncSearch';
import { getIdToken } from 'FielderUtils/session/Session';
import API_LINKS from 'FielderAPILinks';

const SearchInventory = ({ setInventoryValue, idAccount, multiple, size }) => {

    const lan = useLanguage();

    const getInventoryList = (event) => {
        
            const bodySend = {
                type: 'GET_INVENTORY_BY_FILTER',
                idAccount: idAccount,
                filter: event,
            };
    
            return fetch(API_LINKS.functionalityTaskManager, {
                method: 'POST',
                body: JSON.stringify(bodySend),
                headers: {
                    'Content-type': 'application/json',
                    Authorization:  getIdToken(),
                },
            })
                .then((res) => res.json())
                .then((inventoryList) => {
                    if (inventoryList.success == true) {
                        let inventoryListArray = [];
    
                        inventoryList.inventories.forEach((inventory) => {
                            let label = inventory.id + ' - ' + inventory.name + ' [' + inventory.category.name + '] ';
                            let inventoryInfo = [];
    
                            if (inventory.brand) {
                                inventoryInfo.push(inventory.brand + ' (' + lan.brand + ')');
                            }
                            if (inventory.type) {
                                inventoryInfo.push(inventory.type + ' (' + lan.type + ')');
                            }
                            if (inventory.model) {
                                inventoryInfo.push(inventory.model + ' (' + lan.model + ')');
                            }
                            if (inventory.serialNumber) {
                                inventoryInfo.push(inventory.serialNumber + ' (' + lan.serialNumber + ')');
                            }
                            if (inventory.contract) {
                                inventoryInfo.push(inventory.contract + ' (' + lan.contractNumber + ')');
                            }
    
                            label += inventoryInfo.join(' - ');
    
                            inventoryListArray.push({
                                label: label,
                                value: inventory,
                            });
                        });
    
                        return inventoryListArray;
                    }
                });
        };



    return (
        <Col sm={size ? size : 10} className='mx-auto'>
            <AsyncSearch
                className='react-select__control full-width mt-3'
                getOptions={(e) => getInventoryList(e)}
                onChange={(e) => setInventoryValue(e)}
                label={lan.placeHolderInventory}
                lan={lan}
                id='select-agent'
                multiple={multiple ? true : false}
            />
        </Col>
    );
};

export default SearchInventory;
